import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import {
    CreateTaskCategoryGroupInput,
    SetTaskCategoryGroupComplexitySettingsInput,
    UpdateTaskCategoryGroupInput,
    TaskCategoryGroupFilterInput,
} from './inputs';
import { TaskCategoryGroupRef } from './refs';
import { TaskCategoryGroupResource, TaskCategoryGroupListItemResource } from './resources';

export default class TaskCategoryGroup {
    private basePath = '/api/task-category-group';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get task category group list
    get = async (
        filter?: TaskCategoryGroupFilterInput
    ): Promise<CollectionResource<TaskCategoryGroupListItemResource, {}>> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Fetch single task category group
    getById = async (id: ID): Promise<TaskCategoryGroupResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Create new task category group
    create = async (input: CreateTaskCategoryGroupInput): Promise<TaskCategoryGroupRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Update task category group
    update = async (id: ID, input: UpdateTaskCategoryGroupInput): Promise<TaskCategoryGroupRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);

        return data;
    };

    // Archive task category group
    archive = async (id: ID): Promise<TaskCategoryGroupRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);

        return data;
    };

    // Restore archived task category group
    restore = async (id: ID): Promise<TaskCategoryGroupRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/restore`);

        return data;
    };

    // Set task category group complexity settings
    setComplexitySettings = async (
        id: ID,
        input: SetTaskCategoryGroupComplexitySettingsInput
    ): Promise<TaskCategoryGroupResource> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/complexity`, input);

        return data;
    };
}
